module.exports = __webpack_public_path__ + "static/precios-constructores-reigas-086f4196b2145200c4d5141645e9ee9e.pdf";